import { useParams } from "@tanstack/react-router";

export const useSpaceSlugFromUrl = () => {
  const params = useParams({
    from: "/_protected/_dynamicLayout/c/$spaceSlug",
    shouldThrow: false,
  });

  return params?.spaceSlug;
};
